export default __webpack_public_path__ + "static/media/getting_started.18a7172d.svg";